module.exports = __webpack_public_path__ + "9a6c2cee4bad8d80e56f576dfbf82204.svg";